import type { TurnDirection } from "../program/Card";

const SVG_COMMON_ATTRS =
  'viewBox="0 0 36 36" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"';

const TURN_PATHS: Record<TurnDirection, string> = {
  right: '<path d="M10,30 L10,12 L26,12"/><path d="M20,6 L26,12 L20,18"/>',
  left: '<path d="M26,30 L26,12 L10,12"/><path d="M16,6 L10,12 L16,18"/>',
  back: '<path d="M8,30 L8,12 L26,12 L26,30"/><path d="M20,24 L26,30 L32,24"/>',
};

export function getTurnDirectionSVG(direction: TurnDirection): string {
  return `<svg ${SVG_COMMON_ATTRS}>${TURN_PATHS[direction]}</svg>`;
}

export function getWhileIconSVG(): string {
  return `<svg ${SVG_COMMON_ATTRS}><path d="M 28,13 A 11,11 0 0 0 8,13"/><path d="M 7,6 L 8,13 L 15,12"/><path d="M 8,23 A 11,11 0 0 0 28,23"/><path d="M 21,24 L 28,23 L 29,30"/></svg>`;
}

export function getCallIconSVG(): string {
  return `<svg ${SVG_COMMON_ATTRS}><path d="M18 10 Q10 6 3 10 L3 29 Q10 25 18 29 Z"/><path d="M18 10 Q26 6 33 10 L33 29 Q26 25 18 29 Z"/></svg>`;
}
